var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85714 0H12.1429C13.4311 0 14.6665 0.511733 15.5774 1.42262C16.4883 2.33352 17 3.56895 17 4.85714V12.1429C17 13.4311 16.4883 14.6665 15.5774 15.5774C14.6665 16.4883 13.4311 17 12.1429 17H4.85714C3.56895 17 2.33352 16.4883 1.42262 15.5774C0.511733 14.6665 0 13.4311 0 12.1429V4.85714C0 3.56895 0.511733 2.33352 1.42262 1.42262C2.33352 0.511733 3.56895 0 4.85714 0ZM5.92411 11.0759C6.60728 11.7591 7.53385 12.1429 8.5 12.1429C9.46615 12.1429 10.3927 11.7591 11.0759 11.0759C11.7591 10.3927 12.1429 9.46615 12.1429 8.5C12.1429 7.53385 11.7591 6.60728 11.0759 5.92411C10.3927 5.24094 9.46615 4.85714 8.5 4.85714C7.53385 4.85714 6.60728 5.24094 5.92411 5.92411C5.24094 6.60728 4.85714 7.53385 4.85714 8.5C4.85714 9.46615 5.24094 10.3927 5.92411 11.0759ZM13 3C12.7239 3.27614 12.7239 3.72386 13 4C13.2761 4.27614 13.7239 4.27614 14 4C14.2761 3.72386 14.2761 3.27614 14 3C13.7239 2.72386 13.2761 2.72386 13 3Z",
    fill: "#A7ADB7",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaGray);
export default __webpack_public_path__ + "static/media/instaGray.c83e6deb83e942ffe7e9a242895ba947.svg";
export { ForwardRef as ReactComponent };